

export function initializeTabs() {
    if($('.vs-tabs').length == 0) {
        return;
    }
    $('.vs-tabs .vs-tab-link').click(function() {
        if($(this).hasClass('vs-tab-link--active')) {
            return;
        } else {
            $(this).siblings('.vs-tab-link--active').removeClass('vs-tab-link--active');
            $(this).parent().parent().find('.vs-tabs__list .vs-tab--open').removeClass('vs-tab--open');
            $(this).addClass('vs-tab-link--active');
            $(this).parent().parent().find(`.vs-tab[data-id="${$(this).attr('data-id')}"]`).addClass('vs-tab--open');
        }
    });

    function switchTab(next = true) {
        let currentTabIndex = $('.vs-tab-link.vs-tab-link--active').index();
        let totalTabs = $('.vs-tab-link').length;
        let targetTabIndex = next ? (currentTabIndex + 1) % totalTabs : (currentTabIndex - 1 + totalTabs) % totalTabs;

        $('.vs-tab-link').eq(targetTabIndex).trigger('click');
    }

    $('.vs-tabs-button-prev').click(function() {
        switchTab(false);
    });

    $('.vs-tabs-button-next').click(function() {
        switchTab();
    });
}